/**
 * Side Cart Products - Drawer & Quick Add functionality
 * Gestisce il drawer delle varianti che si apre dal basso del side cart
 */

// Global drawer element (creato dinamicamente, condiviso tra tutti i prodotti)
let globalSidecartDrawer = null;
let currentProductData = null;

/**
 * Crea il drawer globale se non esiste
 */
function ensureGlobalDrawer() {
  if (globalSidecartDrawer) return globalSidecartDrawer;

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return null;

  // Trova il modal-inner del cart drawer
  const modalInner = cartDrawer.querySelector('.modal-inner');
  if (!modalInner) return null;

  // Crea il drawer globale con stile collezioni (handle invece di header)
  globalSidecartDrawer = document.createElement('div');
  globalSidecartDrawer.className = 'sidecart-global-drawer';
  globalSidecartDrawer.innerHTML = `
    <div class="sidecart-drawer-overlay" data-close-drawer></div>
    <div class="sidecart-drawer-content">
      <div class="sidecart-drawer-handle"></div>
      <div class="sidecart-drawer-body">
        <div class="sidecart-variant-options-container"></div>
      </div>
    </div>
  `;

  modalInner.appendChild(globalSidecartDrawer);

  // Event listeners per chiudere
  globalSidecartDrawer.querySelectorAll('[data-close-drawer]').forEach(el => {
    el.addEventListener('click', closeGlobalDrawer);
  });

  return globalSidecartDrawer;
}

/**
 * Apre il drawer globale con i dati del prodotto
 */
function openGlobalDrawer(productItem) {
  const drawer = ensureGlobalDrawer();
  if (!drawer) return;

  const productId = productItem.dataset.productId;
  const variantsJson = productItem.querySelector('.sidecart-variants-json');
  const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

  // Trova le info del prodotto
  const localDrawer = productItem.querySelector('sidecart-variant-drawer');
  if (!localDrawer) return;

  // Copia il contenuto delle opzioni nel drawer globale
  const optionsContainer = drawer.querySelector('.sidecart-variant-options-container');
  const localOptions = localDrawer.querySelector('sidecart-quick-add');

  if (localOptions) {
    optionsContainer.innerHTML = localOptions.innerHTML;
  }

  // Salva i dati correnti
  currentProductData = {
    productId,
    variants,
    productItem
  };

  // Aggiungi event listeners alle radio
  setupVariantListeners(optionsContainer);

  // Apri il drawer
  drawer.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

/**
 * Chiude il drawer globale
 */
function closeGlobalDrawer() {
  if (!globalSidecartDrawer) return;

  globalSidecartDrawer.classList.remove('is-open');
  document.body.style.overflow = '';
  currentProductData = null;
}

/**
 * Setup listeners per le varianti
 */
function setupVariantListeners(container) {
  const labels = container.querySelectorAll('.sidecart-variant-label');

  labels.forEach(label => {
    label.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!currentProductData) return;
      if (label.classList.contains('disabled')) return;

      const { variants, productId } = currentProductData;

      // Trova il radio associato alla label
      const radioId = label.getAttribute('for');
      const radio = container.querySelector(`#${CSS.escape(radioId)}`);

      if (!radio) return;

      // Per prodotti single-size (taglia unica)
      if (radio.dataset.singleSize === 'true') {
        const variantId = radio.dataset.variantId;
        if (variantId) {
          addToCart(variantId);
        }
        return;
      }

      // Per prodotti multi-variante (es. solo taglia)
      const optionValue = radio.value;
      const optionPosition = parseInt(radio.dataset.optionPosition);

      // Trova la variante che corrisponde a questa opzione
      const matchingVariant = variants.find(variant => {
        // Controlla se questa opzione corrisponde
        const variantOption = variant[`option${optionPosition}`];
        return variantOption === optionValue && variant.available;
      });

      if (matchingVariant) {
        addToCart(matchingVariant.id);
      }
    });
  });
}

/**
 * Aggiunge al carrello
 */
async function addToCart(variantId) {
  try {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer not found');
      return;
    }

    // Ottieni le sezioni da aggiornare usando il metodo nativo del cart drawer
    const sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.section);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }],
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) throw new Error('Failed to add to cart');

    const responseData = await response.json();

    // Chiudi il drawer delle varianti
    closeGlobalDrawer();

    // Aggiorna il side cart usando il metodo nativo del cart drawer
    cartDrawer.renderContents(responseData);

    // Aggiorna anche l'icona del carrello mobile
    const cartIconMobile = document.querySelector('#cart-icon-bubble-mobile');
    if (cartIconMobile && responseData.sections && responseData.sections['cart-icon-bubble']) {
      const parser = new DOMParser();
      const iconDoc = parser.parseFromString(responseData.sections['cart-icon-bubble'], 'text/html');
      const newCount = iconDoc.querySelector('.cart-count');
      if (newCount) {
        const currentCount = cartIconMobile.querySelector('.cart-count');
        if (currentCount) {
          currentCount.innerHTML = newCount.innerHTML;
        }
      }
    }

  } catch (error) {
    console.error('Error adding to cart:', error);
  }
}


/**
 * Inizializzazione
 */
function initSidecartProducts() {
  // Auto-open su desktop
  const relatedSection = document.querySelector('.drawer__related-products.collapse-block-mobile');
  if (relatedSection && window.innerWidth >= 769) {
    relatedSection.classList.add('is-open');
  }

  // Listener per il toggle "Potrebbero interessarti" su mobile
  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('.related-toggle');
    if (!toggleBtn) return;

    e.preventDefault();
    const collapseBlock = toggleBtn.closest('.collapse-block-mobile');
    if (collapseBlock) {
      // Rimuovi is-open-mobile se presente (stato iniziale aperto)
      if (collapseBlock.classList.contains('is-open-mobile')) {
        collapseBlock.classList.remove('is-open-mobile');
      } else {
        collapseBlock.classList.toggle('is-open');
      }
    }
  });

  // Listener per "chiudi i suggerimenti" su desktop
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.close-suggestions-btn');
    if (!closeBtn) return;

    e.preventDefault();
    const collapseBlock = closeBtn.closest('.collapse-block-mobile');
    if (collapseBlock) {
      collapseBlock.classList.remove('is-open');
    }
  });

  // Listener per i pulsanti "+"
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.sidecart-add-btn');
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const productItem = addBtn.closest('.sidecart-product-item');
    if (productItem) {
      openGlobalDrawer(productItem);
    }
  });

  // Chiudi con ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && globalSidecartDrawer?.classList.contains('is-open')) {
      closeGlobalDrawer();
    }
  });
}

// Custom Elements
class SidecartVariantDrawer extends HTMLElement {
  constructor() {
    super();
  }
}

class SidecartQuickAdd extends HTMLElement {
  constructor() {
    super();
  }
}

// Registra i custom elements se non esistono già
if (!customElements.get('sidecart-variant-drawer')) {
  customElements.define('sidecart-variant-drawer', SidecartVariantDrawer);
}

if (!customElements.get('sidecart-quick-add')) {
  customElements.define('sidecart-quick-add', SidecartQuickAdd);
}

/**
 * Custom Element per caricare i prodotti correlati via AJAX
 */
class SidecartRelatedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.type === 'auto') {
      this.loadRecommendations();
    }
  }

  initNavigationArrows(slideSection) {
    const container = this.closest('.drawer__related-products');
    if (!container) return;

    const prevBtn = container.querySelector('.swiper-button-prev');
    const nextBtn = container.querySelector('.swiper-button-next');

    if (!prevBtn || !nextBtn) return;

    // Attendi che lo swiper sia inizializzato
    const checkSwiper = setInterval(() => {
      const swiper = slideSection.swiper;
      if (swiper) {
        clearInterval(checkSwiper);

        // Rimuovi eventuali listener precedenti clonando i bottoni
        const newPrevBtn = prevBtn.cloneNode(true);
        const newNextBtn = nextBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
        nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);

        // Aggiungi i nuovi listener
        newPrevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          swiper.slidePrev();
        });

        newNextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          swiper.slideNext();
        });

        // Aggiorna stato disabled delle frecce
        const updateArrows = () => {
          newPrevBtn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
          newNextBtn.classList.toggle('swiper-button-disabled', swiper.isEnd);
        };

        updateArrows();
        swiper.on('slideChange', updateArrows);
      }
    }, 100);

    // Timeout di sicurezza
    setTimeout(() => clearInterval(checkSwiper), 3000);
  }

  async loadRecommendations() {
    const url = this.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = document.createElement('div');
      html.innerHTML = text;

      const wrapper = html.querySelector('.swiper-wrapper');
      if (wrapper && wrapper.children.length > 0) {
        const localWrapper = this.querySelector('.swiper-wrapper');
        if (localWrapper) {
          localWrapper.innerHTML = wrapper.innerHTML;
        }

        // Mostra il container
        const container = this.closest('.drawer__cart-recommendations');
        if (container) {
          container.classList.remove('hidden');
        }

        // Reinizializza Swiper
        const slideSection = this.querySelector('slide-section');
        if (slideSection) {
          // Prova diversi metodi per inizializzare lo swiper
          if (typeof slideSection.initSwiper === 'function') {
            slideSection.initSwiper();
          } else if (typeof slideSection.init === 'function') {
            slideSection.init();
          } else if (slideSection.swiper) {
            slideSection.swiper.update();
          } else {
            // Forza re-render del componente
            const parent = slideSection.parentNode;
            const clone = slideSection.cloneNode(true);
            parent.replaceChild(clone, slideSection);
          }

          // Collega le frecce di navigazione
          this.initNavigationArrows(slideSection);
        }
      } else {
        // Nascondi se non ci sono prodotti
        const container = this.closest('.drawer__cart-recommendations');
        if (container) {
          container.classList.add('hidden');
        }
      }
    } catch (error) {
      console.error('Error loading related products:', error);
    }
  }
}

if (!customElements.get('sidecart-related-products')) {
  customElements.define('sidecart-related-products', SidecartRelatedProducts);
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSidecartProducts);
} else {
  initSidecartProducts();
}
